import { normalizeAllowedRedirectPath } from "@miadvg/auth-gateway";

export const RESURRECTION_STAFF_APP_SLUG = "resurrection";
export const RESURRECTION_STAFF_AUTH_CALLBACK_PATH = "/auth/callback";
export const RESURRECTION_STAFF_SIGN_OUT_PATH = "/api/auth/sign-out";

export function normalizeResurrectionStaffRedirectPath(
  rawValue: string | null | undefined,
): string {
  return normalizeAllowedRedirectPath(rawValue, {
    fallback: "/staff",
    allowedPrefixes: ["/staff", "/resurrect"],
  });
}
